import { query } from "@solidjs/router";
import { retrieveOrders } from "../roma-api/account";

export const useOrders = query(async (days: number) => retrieveOrders(days), "orders");
